import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import QuizLiveAnswer from '../components/quiz-live-answer';

import QuizControls from '../components/speaker-mode/quiz-controls';


const answerswithResults = [
  {
    id: 1,
    answer: "Answer Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh",
    totalAnswers: 100,
    value: true
  },
  {
    id: 2,
    answer: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Rerum, totam?",
    totalAnswers: 20,
    value: true
  },
  {
    id: 3,
    answer: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Rerum, totam?",
    totalAnswers: 0,
    value: false
  },
  {
    id: 4,
    answer: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Rerum, totam?",
    totalAnswers: 50,
    value: false
  },
 
]


const QuizAnswerResults:React.FC = () => {

  return (
    <div className="answers-results-container quiz-live-screen-container">
        <div className="answers-main">
          <Container fluid>
            <Row>
              <Col>
                <div className="quiz-live-answers-container m-t-60">
                  <h5>question 1/5</h5>
                  <p className="q">First off — what does the 3rd R of the AARRR Funnel stand for?</p>
                  {
                    answerswithResults.map((answer, index) => (
                      <QuizLiveAnswer
                        totalAnswersAggregate={123}
                        answerLength={answerswithResults.length}
                        key={answer.id}
                        alphabet={String.fromCharCode(index + 97)}
                        answer={answer.answer}
                        totalAnswers={answer.totalAnswers}
                        value={answer.value}
                      />
                    ))
                  }
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      <QuizControls answerId="asd" usersLength={200} answersLength={50} />
    </div>
  )
}

export default QuizAnswerResults;